import {
  fetch
} from '@/helper/http.js';

export function checkMemberApply($router) {
  fetch(
    '/api/OrganizationEnterprise/GetOrganizationApplyStatus'
  ).then(result => {
    const status = result;
    let path = '';
    switch (status) {
      case 3:
        // 等待审核
        path += '/member/apply/wait';
        break;
      case 4:
        // 申请通过，准备进行下一流程s
        path += '/member/apply/audit-success';
        break;
      case 5:
        // 审批被拒绝
        path += '/member/apply/audit-fail';
        break;
      case 6:
        // 申请完成，已成为正式会员
        path += '/member/apply/finish';
        break;
      case 7:
        // 等待线下汇款确认
        path += '/member/pay/remit-confirm';
        break;
      default:
        path = '/member/apply';
        break;
    }

    $router.push({
      path,
    });
  });
}
